import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';
import {
    initializeFirestore,
    Firestore,
    connectFirestoreEmulator,
} from 'firebase/firestore/lite';
import {
    getFunctions,
    connectFunctionsEmulator,
    type Functions,
} from 'firebase/functions';
import {
    getStorage,
    connectStorageEmulator,
    type FirebaseStorage,
} from 'firebase/storage';

export let auth: Auth;
export let db: Firestore;
export let functions: Functions;
export let functionsEuropeWest3: Functions;
export let storage: FirebaseStorage;
export let analytics: any;

let firebaseInitialized = false;

export function isRunningInEmulator() {
    const correctHost =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';
    const correctPort = window.location.port === '5173'; // Vite dev server port

    return correctHost && correctPort;
}

export async function initializeFirebase() {
    if (firebaseInitialized) return true;

    const development =
        import.meta.env.MODE === 'development' || isRunningInEmulator();

    try {
        let firebaseConfig;

        if (development) {
            firebaseConfig = envConfig;
        } else {
            const response = await fetch('/__/firebase/init.json');
            firebaseConfig = await response.json();
        }

        // Initialize the Firebase app
        const app = initializeApp(firebaseConfig);

        // Initialize all the services
        if (import.meta.env.MODE === 'production') {
            analytics = getAnalytics(app);
        }

        db = initializeFirestore(app, {
            ignoreUndefinedProperties: true,
        });

        auth = getAuth(app);
        functions = getFunctions(app);
        functionsEuropeWest3 = getFunctions(app, 'europe-west3');
        storage = getStorage(app);

        // Connect to emulators in development mode
        if (development) {
            console.log('Connecting to Firebase emulators');
            connectFirestoreEmulator(db, 'localhost', 8080);
            connectAuthEmulator(auth, 'http://localhost:9099');
            connectFunctionsEmulator(functions, 'localhost', 5001);
            connectFunctionsEmulator(functionsEuropeWest3, 'localhost', 5001);
            connectStorageEmulator(storage, 'localhost', 9199);
        }

        // Mark as initialized
        firebaseInitialized = true;
        return true;
    } catch (error) {
        console.error('Failed to initialize Firebase:', error);
        throw error;
    }
}

const envConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// export async function getFirebaseServices() {
//     if (!firebaseInitialized) {
//         await initializeFirebase();
//     }
//     return {
//         auth,
//         db,
//         functions,
//         functionsEuropeWest3,
//         storage,
//         analytics,
//     };
// }
